import { Heading, SimpleGrid, Button } from "@chakra-ui/react";
import { Meta, Card, Search, Reload } from "@/components/index";
import { useFetch } from "@/hooks/useFetch";
export default function Home() {
  const { status, data, error, isFetching } = useFetch(
    "https://api.axenda.io/schools",
    "schools"
  );

  return (
    <Meta
      title="Main Page"
      description="Axenda Drive main Page"
      image="https://axed.vercel.app/favicon-512.png"
    >
      <main>
        <Heading as="h1" textAlign="center" paddingY={"12"}>
          Hello in the 💽
        </Heading>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            aria-label="Go Chooes your university"
            as="a"
            href="#unis"
            textColor="blue.200"
          >
            Chooes your university 🛖
          </Button>
        </div>
        {error ? (
          <Reload size="xl" text={"Reload"} />
        ) : (
          <div id="unis">
            <Search ph="University Name" />
            <SimpleGrid
              columns={[1, 2, 3, 4]}
              gap={8}
              justifyItems="center"
              justifyContent="space-evenly"
              alignContent="space-evenly"
              alignItems="center"
              // minChildWidth={["14rem", "16rem", "18rem"]}
              m={8}
            >
              {data?.map((deta, id) => {
                return (
                  <Card
                    key={deta._id != null ? deta._id : id}
                    img={deta.logoUrl}
                    slug={deta.slug}
                    name={deta.autocomplete}
                    simple
                  ></Card>
                );
              })}
            </SimpleGrid>
          </div>
        )}
      </main>
    </Meta>
  );
}
